/**************************************************
 * Nombre:       Dialogo_Deposito
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../Recursos/logo_redondo.svg'
import {Check, CreditCard, CurrencyBitcoin, Delete} from "@mui/icons-material";
import {borrarDoc} from "../../Servicios/BD/borrarDoc";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import Formulario_Deposito from "../Formularios/Formulario_Deposito";
import {crearLinkPago} from "../../CodNegocio/crearLinkPago";
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {irUrl} from "../../Utilidades/irUrl";
import {obtenerConsecutivo} from "../../Servicios/BD/Consecutivos/obtenerConsecutivo";
import {aumentarConsecutivo} from "../../Servicios/BD/Consecutivos/aumentarConsecutivo";
import {useContext, useState} from "react";
import {usuarioContext} from "../../App";
import Formulario_Deposito_Captura from "../Formularios/Formulario_Deposito_Captura";
import {subirImagenHostingFile} from "../../Servicios/AlmacenamientoHosting/subirImagenHostingFile";
import {enviarPeticion} from "../../Modulo_Peticiones/Peticiones/enviarPeticion";

const Dialogo_Deposito = ({datos, cerrar, realizado}) => {
    const cData = useContext(usuarioContext);
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const [esCripto, setEsCripto] = useState(false)

    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })

    const depositoTarjeta = async () => {

        let entidad = await obtenerEntidad()

        if (entidad.valor <= 0) {
            terminar({aviso: 'No se pueden crear depositos sin un valor positivo', variante: 'error'})
            return
        }

        iniciarCarga('Subiendo Datos')

        entidad.fecha = new Date().getTime()
        entidad.id = new Date().getTime() + 'TOS'
        entidad.estado = 'Nuevo'
        entidad.mensaje = 'El deposito esta siendo validado'
        entidad.tipo = 'Deposito'
        let conse = await obtenerConsecutivo({col: 'consecutivos', id: 'depositos'})
        entidad.consecutivo = conse.data
        entidad.idUsuario = cData.usuario.id
        entidad.nombreUsuario = cData.usuario.nombres + ' ' + cData.usuario.apellidos
        entidad.metodo = 'Tarjeta'

        let res = await crearLinkPago({entidad: entidad})

        if (res.res) {
            irUrl(res.data)
            let dox = await guardarDoc('depositos', entidad)
            if (dox.res) {
                await aumentarConsecutivo({col: 'consecutivos', id: 'depositos', actual: entidad.consecutivo})
                await enviarPeticion({datos: entidad, flujo: 'noti_admin'})
                terminar({aviso: 'Tu deposito sera validado en un plazo de 24 horas'})
            } else {
                terminar({aviso: 'Algo salio mal, por favor intetalo nuevamente', variante: 'error'})
            }
        } else {
            terminar({aviso: 'No hemos podido dirigirte a nuestra pasarela de pagos', variante: 'error'})
        }

    }

    const depositoCripto = async () => {

        setEsCripto(true)

    }

    const subirDepositoCripto = async () => {

        let entidad = await obtenerEntidad()

        if (entidad.valor <= 0) {
            terminar({aviso: 'No se pueden crear depositos sin un valor positivo', variante: 'error'})
            return
        }

        if (!entidad.img) {
            terminar({aviso: 'Subir la captura de pantalla de la transacción'})
            return
        }

        iniciarCarga('Subiendo Datos')

        let imgDox = await subirImagenHostingFile(entidad.img)
        entidad.img = imgDox.data

        entidad.fecha = new Date().getTime()
        entidad.id = new Date().getTime() + 'TOS'
        entidad.estado = 'Nuevo'
        entidad.mensaje = 'El deposito esta siendo validado'
        entidad.tipo = 'Deposito'
        let conse = await obtenerConsecutivo({col: 'consecutivos', id: 'depositos'})
        entidad.consecutivo = conse.data
        entidad.idUsuario = cData.usuario.id
        entidad.nombreUsuario = cData.usuario.nombres + ' ' + cData.usuario.apellidos
        entidad.metodo = 'Cripto'

        let dox = await guardarDoc('depositos', entidad)

        if (dox.res) {
            await aumentarConsecutivo({col: 'consecutivos', id: 'depositos', actual: entidad.consecutivo})
            await enviarPeticion({datos: entidad, flujo: 'noti_admin'})
            terminar({aviso: 'Tu deposito sera validado en un plazo de 24 horas'})
        } else {
            terminar({aviso: 'Algo salio mal, por favor intetalo nuevamente', variante: 'error'})
        }


    }

    const borrar = async () => {
        iniciarCarga('Borrando')
        await borrarDoc('depositos', datos.id)
        terminar({aviso: 'deposito borrado'})
    }
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Deposito props={props}/>
            </Grid>

            {esCripto ?

                <>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 2}}>
                        <Formulario_Deposito_Captura props={props}/>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                        <Button
                            startIcon={<Check/>}
                            onClick={() => subirDepositoCripto()}
                        >Subir Deposito</Button>
                    </Grid>

                </>

                :

                <>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 3}}>
                        <Typography>Escoge el metodo de deposito</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'center', marginTop: 3}}>
                        <Button
                            fullWidth
                            startIcon={<CurrencyBitcoin/>}
                            onClick={() => depositoCripto()}
                        >Depositar con Cripto</Button>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'center', marginTop: 2}}>
                        <Button
                            fullWidth
                            variant={'outlined'}
                            startIcon={<CreditCard/>}
                            onClick={() => depositoTarjeta()}
                        >Depositar con Tarjeta</Button>
                    </Grid>

                </>

            }

            {datos && datos.id &&
                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Button
                        onClick={() => borrar()}
                        color={'success'} startIcon={<Delete/>} variant={'text'}>
                        Borrar
                    </Button>
                </Grid>
            }

        </Grid>
    )

}
export default Dialogo_Deposito